import React from 'react';
import { Device } from '../../../../../redux/commander/api/device.model';
import { getPolyglot } from '../../../../../i18n';
import BrowserUtil from '../../../../../util/BrowserUtil';
import { useParams } from 'react-router-dom';
import { useAppSelector } from '../../../../../redux/store.model';
import { getCommanderLabelsSelector } from '../../../../../redux/commander/selectors/labels';

interface DeviceLabelProps {
  device: Device;
}
const browserUtil = new BrowserUtil();

function DeviceLabel(props: DeviceLabelProps) {
  const { device } = props;
  const { groupId } = useParams();
  const label = useAppSelector((state) =>
    getCommanderLabelsSelector(state, { groupId, deviceId: device.uuid })
  );

  const polyglot = getPolyglot();
  if (!label) {
    return null;
  }
  let labelString = polyglot.t(`device.label.${label}`);
  /** by mobile we don't have much space at the left side. Since the Label is
   * placed there, we should show only a symbol to indicate that there is a label
   * */
  if (browserUtil.getIsMobile()) {
    labelString = '*';
  }
  return (
    <div
      className={`label-device ${label} ${
        browserUtil.getIsMobile() ? 'mobil' : ''
      }`}
    >
      {labelString}
    </div>
  );
}

export default DeviceLabel;
